import { $http } from "@/utils/https";
import {
    LINK_ACCOUNT_LOADING,
    POPUP_USER_CONTACTS_CHANGE,
    SEND_REQUEST_CHANGE_EMAIL_LOADING,
    SEND_REQUEST_CHANGE_PHONE_LOADING,
    UNLINK_ACCOUNT_LOADING,
    USER_REMOVE_SOCIAL_PROVIDER,
    USER_UPDATE_DATA,
} from "./types/mutation-types";

import {
    LINK_ACCOUNT,
    SEND_REQUEST_CHANGE_CONTACTS,
    SEND_REQUEST_CHANGE_CONTACTS_EMAIL,
    SEND_REQUEST_CHANGE_CONTACTS_PHONE,
    UNLINK_ACCOUNT,
} from "./types/action-types";

const state = {
    linkAccountRequest: {
        status: false,
        provider: "",
    },
    unlinkAccountRequest: {
        status: false,
        provider: "",
    },
    changePhoneRequestStatus: false,
    changeEmailRequestStatus: false,
    showPopupUserContacts: {
        show: false,
        requestedPhone: false,
        requestedEmail: false,
    },
};

const getters = {
    linkAccountRequest: (state) => state.linkAccountRequest,
    unlinkAccountRequest: (state) => state.unlinkAccountRequest,
    changePhoneRequestStatus: (state) => state.changePhoneRequestStatus,
    changeEmailRequestStatus: (state) => state.changeEmailRequestStatus,
    showPopupUserContacts: (state) => state.showPopupUserContacts,
};

const actions = {
    [LINK_ACCOUNT]: async ({ commit }, payload) => {
        try {
            commit(LINK_ACCOUNT_LOADING, {
                status: true,
                provider: payload.provider,
            });

            const response = await $http.post(
                `${process.env.VUE_APP_ROOT_USER}profile/socials`,
                payload
            );

            commit(`user/${USER_UPDATE_DATA}`, response.data.data, { root: true });
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(LINK_ACCOUNT_LOADING, {
                status: false,
                provider: payload.provider,
            });
        }
    },
    [UNLINK_ACCOUNT]: async ({ commit }, payload) => {
        try {
            commit(UNLINK_ACCOUNT_LOADING, {
                status: true,
                provider: payload.provider,
            });

            const response = await $http.post(
                `${process.env.VUE_APP_ROOT_USER}profile/socials/${payload.id}`,
                payload
            );
            commit(`user/${USER_REMOVE_SOCIAL_PROVIDER}`, payload, { root: true });
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(UNLINK_ACCOUNT_LOADING, {
                status: false,
                provider: payload.provider,
            });
        }
    },
    [SEND_REQUEST_CHANGE_CONTACTS]: async ({ commit }, payload) => {
        try {
            return await $http.post(
                `${process.env.VUE_APP_ROOT_USER}profile/contacts`,
                payload
            );
        } catch (e) {
            throw e;
        }
    },
    [SEND_REQUEST_CHANGE_CONTACTS_EMAIL]: async ({ commit }, payload) => {
        try {
            return await $http.post(
                `${process.env.VUE_APP_ROOT_USER}profile/contacts/email`,
                payload
            );
        } catch (e) {
            throw e;
        }
    },
    [SEND_REQUEST_CHANGE_CONTACTS_PHONE]: async ({ commit }, payload) => {
        try {
            return await $http.post(
                `${process.env.VUE_APP_ROOT_USER}profile/contacts/phone`,
                payload
            );
        } catch (e) {
            throw e;
        }
    },
};

const mutations = {
    [LINK_ACCOUNT_LOADING](state, status) {
        state.linkAccountRequest = status;
    },
    [UNLINK_ACCOUNT_LOADING](state, status) {
        state.unlinkAccountRequest = status;
    },
    [SEND_REQUEST_CHANGE_PHONE_LOADING](state, status) {
        state.changePhoneRequestStatus = status;
    },
    [SEND_REQUEST_CHANGE_EMAIL_LOADING](state, status) {
        state.changeEmailRequestStatus = status;
    },
    [POPUP_USER_CONTACTS_CHANGE](state, status) {
        state.showPopupUserContacts = { ...state.showPopupUserContacts, ...status };
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
